import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { css, Label } from './UI';

// Catálogo de motivos de rechazo de requisiciones (lo edita el admin en
// Administración → Aprobación de requisiciones). Al rechazar en cualquier etapa
// se elige uno y se escribe el detalle; el reporte de compras agrupa por él.
export function useMotivosRechazo() {
  const [motivos, setMotivos] = useState([]);
  useEffect(() => { api.get('/motivos-rechazo-requisicion').then(setMotivos).catch(() => {}); }, []);
  return motivos;
}

export function SelectMotivoRechazo({ value, onChange, motivos }) {
  return (
    <div>
      <Label required>Motivo del rechazo</Label>
      <select value={value} onChange={e => onChange(e.target.value)} style={css.select(!value)}>
        <option value="">Elige un motivo…</option>
        {motivos.map(m => <option key={m._id} value={m.nombre}>{m.nombre}</option>)}
      </select>
    </div>
  );
}

// Administración del catálogo (solo admin). Desactivar en lugar de borrar: los
// rechazos anteriores siguen citando el motivo y el reporte los agrupa igual.
export function CatalogoMotivosRechazo({ avisar }) {
  const [motivos, setMotivos] = useState([]);
  const [nuevo, setNuevo] = useState('');
  const [editando, setEditando] = useState(null); // { id, nombre }
  const cargar = () => api.get('/motivos-rechazo-requisicion?todos=1').then(setMotivos).catch(e => avisar(e.message, 'error'));
  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const guardar = async (fn, ok) => {
    try { await fn(); avisar(ok); cargar(); return true; } catch (e) { avisar(e.message, 'error'); return false; }
  };
  const agregar = () => nuevo.trim() && guardar(() => api.post('/motivos-rechazo-requisicion', { nombre: nuevo.trim() }), 'Motivo agregado').then(ok => ok && setNuevo(''));
  const renombrar = () => guardar(() => api.put(`/motivos-rechazo-requisicion/${editando.id}`, { nombre: editando.nombre }), 'Motivo actualizado').then(ok => ok && setEditando(null));
  const mover = (i, d) => {
    if (!motivos[i + d]) return;
    const lista = [...motivos];
    [lista[i], lista[i + d]] = [lista[i + d], lista[i]];
    // Se renumera toda la lista para que el orden quede consecutivo
    guardar(() => Promise.all(lista.map((m, n) => m.orden === n ? null : api.put(`/motivos-rechazo-requisicion/${m._id}`, { orden: n }))), 'Orden actualizado');
  };
  const btn = { ...css.btnGhost, fontSize: 12, padding: '4px 10px' };

  return (
    <div style={{ ...css.card, padding: 0, marginBottom: 18, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--mesh-soft)' }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 15, fontWeight: 700, color: 'var(--ink)' }}>Motivos de rechazo</h3>
        <div style={{ fontSize: 12.5, color: 'var(--glass)' }}>Quien rechaza una requisición, en cualquier etapa, elige uno de estos motivos y escribe el detalle. El reporte de compras agrupa los rechazos por motivo.</div>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <tbody>
          {motivos.map((m, i) => (
            <tr key={m._id} style={{ borderTop: i ? '1px solid var(--mesh-soft)' : 'none', opacity: m.activo ? 1 : 0.55 }}>
              <td style={{ padding: '8px 20px' }}>
                {editando?.id === m._id
                  ? <input autoFocus value={editando.nombre} onChange={e => setEditando(x => ({ ...x, nombre: e.target.value }))} onKeyDown={e => e.key === 'Enter' && renombrar()} style={css.input(!editando.nombre.trim())} />
                  : <>{m.nombre}{!m.activo && <span style={{ color: 'var(--glass)', fontSize: 12 }}> (desactivado)</span>}</>}
              </td>
              <td style={{ padding: '8px 20px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                {editando?.id === m._id ? <>
                  <button type="button" onClick={renombrar} style={{ ...btn, marginRight: 6 }}>Guardar</button>
                  <button type="button" onClick={() => setEditando(null)} style={btn}>Cancelar</button>
                </> : <>
                  <button type="button" onClick={() => mover(i, -1)} disabled={!i} aria-label="Subir" style={{ ...btn, marginRight: 4 }}>↑</button>
                  <button type="button" onClick={() => mover(i, 1)} disabled={i === motivos.length - 1} aria-label="Bajar" style={{ ...btn, marginRight: 6 }}>↓</button>
                  <button type="button" onClick={() => setEditando({ id: m._id, nombre: m.nombre })} style={{ ...btn, marginRight: 6 }}>Renombrar</button>
                  <button type="button" onClick={() => guardar(() => api.put(`/motivos-rechazo-requisicion/${m._id}`, { activo: !m.activo }), m.activo ? 'Motivo desactivado' : 'Motivo activado')} style={btn}>{m.activo ? 'Desactivar' : 'Activar'}</button>
                </>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ padding: '12px 20px', borderTop: '1px solid var(--mesh-soft)', display: 'flex', gap: 8 }}>
        <input value={nuevo} onChange={e => setNuevo(e.target.value)} onKeyDown={e => e.key === 'Enter' && agregar()} placeholder="Nuevo motivo, ej. Fuera de política de compras" style={{ ...css.input(false), flex: 1 }} />
        <button type="button" onClick={agregar} disabled={!nuevo.trim()} style={css.btn('primario')}>Agregar</button>
      </div>
    </div>
  );
}
